import data from './data.json';

const api = () => {
  return data;
}

export default api;